import http from '@/utils/request';

const BaseServices = {
  uploadApp(params) {
    return http.request({
      url: '/auth/apps/update', method: 'POST', data: params,
    });
  },
};
export default BaseServices;